import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';
import html2canvas from 'html2canvas';
import download from 'downloadjs';

function base64ToArrayBuffer(base64) {
  var binaryString = atob(base64);
  var bytes = new Uint8Array(binaryString.length);
  for (var i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

function blobToBase64(blob) {
  try {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result);
      };

      reader.readAsDataURL(blob);
    });
  } catch (err) {
    console.warn(err);
    return null;
  }
}

interface IGeneratePDFFromCanvas {
  imgSize: { width: number; height: number };
  scale: number;
  id: string;
  fileName: string | undefined;
  imgSrc: string | undefined;
  imgType: 'svg' | 'png' | 'PNG' | 'jpg' | 'JPG' | 'jpeg' | 'JPEG';
  certificateType: 'template' | 'custom';
  onComplete: () => void;
}

async function generatePDFFromCanvas({
  imgSize,
  scale,
  id,
  fileName,
  imgSrc,
  imgType,
  certificateType,
  onComplete,
}: IGeneratePDFFromCanvas) {
  html2canvas(document.querySelector(`#${id}`) as HTMLElement, {
    scale,
    allowTaint: true,
    useCORS: true,
    backgroundColor: null,
  }).then(canvas => {
    canvas.toBlob(async (blob: any) => {
      //

      const displayGeneratedPDFOutput = document.querySelector(
        '#display-generated-pdf-output'
      );

      if (displayGeneratedPDFOutput) {
        const newImg = document.createElement('img');

        const url = URL.createObjectURL(blob);

        newImg.onload = img => {
          URL.revokeObjectURL(url);
        };

        newImg.crossOrigin = 'anonymous';
        newImg.src = url;

        displayGeneratedPDFOutput.appendChild(newImg);
      }

      let imgBytes = await blobToBase64(blob);

      if (imgBytes) {
        imgBytes = base64ToArrayBuffer(
          (imgBytes as string).replace('data:image/png;base64,', '')
        );
      }

      const pdfDoc = await PDFDocument.create();

      let embedImgType;
      //
      if (['png', 'PNG'].includes(imgType)) {
        embedImgType = 'embedPng';
      }

      if (['jpg', 'JPG', 'jpeg', 'JPEG'].includes(imgType)) {
        embedImgType = 'embedJpg';
      }

      if (imgType?.toLowerCase() === 'svg') {
        embedImgType = 'embedSvg';
      }

      let img;

      try {
        img = await pdfDoc[embedImgType](
          imgBytes as string | Uint8Array | ArrayBuffer
        );
      } catch (err) {
        console.warn(
          `using the dynamic 'embedImgType' has failed. likely because we're using the blob so. . . falling back to embedPNG`,
          err
        );
        img = await pdfDoc.embedPng(
          imgBytes as string | Uint8Array | ArrayBuffer
        );
      }

      const page = pdfDoc.addPage([imgSize?.width || 0, imgSize?.height || 0]);

      page.drawImage(img, {
        x: 0,
        y: 0,
        width: imgSize?.width,
        height: imgSize?.height,
      });

      const scale = 1024 / imgSize?.width;

      console.log('GENERATED PDF INFO: ', {
        width: imgSize?.width,
        'pdfScale res ?': scale,
        imgType,
        embedImgType,
      });

      page.scale(scale, scale);

      const pdfBytes = await pdfDoc.save();

      download(pdfBytes, `${fileName || 'Certificate'}.pdf`, 'application/pdf');

      onComplete();
    });

    //
  });
}

export { generatePDFFromCanvas };
